<div
  *ngIf="document && content"
  [ngClass]="{ 'has-edit-button': page.isPreview() }"
  edsPadding
  [edsPaddingBottom]="padding"
  [edsPaddingTop]="padding"
  [edsSpacing]="marginBottom ? marginBottom : defaultMarginBottom"
>
  <ng-container *ngIf="hasMeta">
    <ng-container [brManageContentButton]="document"></ng-container>
  </ng-container>

  <eds-title edsSpacing="md">{{ content.displayName }}</eds-title>

  <ng-container *ngFor="let pageBean of content.pageBeans">
    <form>
      <ng-container *ngFor="let fieldBean of pageBean.fieldBeans">
        <!-- Text Field -->
        <ng-container *ngIf="fieldBean.type === 'TEXT_FIELD'">
          <div edsSpacing="lg">
            <eds-text-input
              type="text"
              [placeholder]="fieldBean.hint"
              [label]="fieldBean.label"
              [required]="fieldBean.mandatory"
              [(value)]="fieldBean.initialValue"
            ></eds-text-input>
          </div>
          <!--  -->
        </ng-container>

        <!-- Text Area -->
        <ng-container *ngIf="fieldBean.type === 'TEXTAREA'">
          <div edsSpacing="lg">
            <textarea rows="4" cols="50"></textarea>
          </div>
        </ng-container>
      </ng-container>

      <div edsSpacing="lg">
        <button edsButton>Submit</button>
      </div>
    </form>
  </ng-container>
</div>

<!-- no document -->
<div *ngIf="!document && page.isPreview()" class="no-document">
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>Custom Form</strong>
    </div>
  </div>
</div>
